module.exports = __webpack_public_path__ + "img/logo_paipai.530ef32a.png";